interface StructuredDataProps {
  type: 'WebSite' | 'Article' | 'Course'
  data: Record<string, unknown>
}

export const StructuredData = ({ type, data }: StructuredDataProps) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  )
}
